import { render, staticRenderFns } from "./TwitchAuthView.vue?vue&type=template&id=4cc22b0a"
import script from "./TwitchAuthView.vue?vue&type=script&lang=js"
export * from "./TwitchAuthView.vue?vue&type=script&lang=js"
import style0 from "./TwitchAuthView.vue?vue&type=style&index=0&id=4cc22b0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports